//  Component: AuthorHome
//  Purpose: Manages Video Search Filters and Displaying Video Data within a Table.
//  Key Features:
//  Handles GET Request and Read operation for Video.
//  Dispatches Redux actions to interact with backend services.

// Importing necessary modules and components
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { RiEdit2Line } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../utils/loader";
import { useDispatch, useSelector } from "react-redux";
import { BsEye } from "react-icons/bs";

// Importing constants and Redux actions
import {
    AUTHOR_STATUS,
} from "../../../constants/cms";
import { getAuthorListing } from "../../../../store/slices/authorProfile"
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../constants/cms";
import { RiDeleteBinFill } from "react-icons/ri";

function AuthorHome(props) {
    // State variables to manage form inputs and table data
    const [tableData, setTableData] = useState(null);
    const [totalRows, setTotalRows] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableCustomData, setTableCustomData] = useState(null)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [status, setStatus] = useState(null);
    let navigate = useNavigate();

    const dispatch = useDispatch();
    const { authorListingLoading, authorListingData, deleteAuthorProfileData } = useSelector((state) => {
        return state.authorReducer; // Returning the desired state values
    });

    // Fetch initial data on component mount
    useEffect(() => {
        dispatch(getAuthorListing())
    }, [])

    // Update table data when video listing data changes
    useEffect(() => {
        if (authorListingData) {
            setTableData(authorListingData?.results);
            setTotalRows(authorListingData?.totalRows);
        }
    }, [authorListingData]);
    // Fetch data for the current page when page changes
    useEffect(() => {
        if (currentPage) {
            let params = {};
            params.page = currentPage;
            params.page_size = perPage;
            dispatch(getAuthorListing(params))
            setTableData(authorListingData?.results);
            setTotalRows(authorListingData?.totalRows);
            // Define table column data
            setTableCustomData([
                {
                    name: "Id",
                    selector: (row) => row.id,
                },
                {
                    name: "Name",
                    selector: (row) => row.name,
                },
                {
                    name: "Email",
                    selector: (row) => row.email,
                },
                {
                    name: "Mobile Number",
                    selector: (row) => row.phone_number,
                },
                {
                    name: "Status",
                    cell: (row, index, column, id) => (
                        <div>
                            {showAuthorStatus(row.status)}
                        </div>
                    ),
                    center: "true",
                },
                {
                    name: "Author Type",
                    selector: (row) => row.author_type,
                },
                {
                    name: "Publishing Domain",
                    selector: (row) => row.domain,
                },
                {
                    name: "Action",
                    selector: (row) => row.action,
                    cell: (row, index, column, id) => (
                        <>
                            {row.alias && <div>
                                <a href={row.alias} target="_blank">
                                    {" "}
                                    <span className={"icon_view"}>
                                        <BsEye />
                                    </span>
                                </a>
                            </div>}
                            <div>
                                <Link to={`/cms/author/manage-author-profile/${row.id}`}>
                                    {" "}
                                    <span className={"icon_edit"}>
                                        <RiEdit2Line />
                                    </span>
                                </Link>
                            </div >
                            <div>
                                <span className={"icon_edit"}>
                                    <RiDeleteBinFill
                                        onClick={() => {
                                            if (window.confirm('Are you sure you want to Unpublish this Author?')) {
                                                navigate(`/cms/author/manage-author-profile/${row.id}/delete`)
                                            }
                                        }}
                                    />
                                </span>
                            </div>
                        </>
                    ),
                    allowOverflow: true,
                    center: "true",
                },
            ]);
        }
    }, [currentPage]);

    // Handler for changing pages
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Handler for changing number of rows per page
    const handlePerRowsChange = (newPerPage, page) => {
        let params = {};
        params.page = page;
        params.page_size = newPerPage;
        dispatch(getAuthorListing(params))
        setPerPage(newPerPage);
    };

    const showAuthorStatus = (status) => {
        let statusLabel = AUTHOR_STATUS.find(
            (obj) => obj.value == status
        );
        return statusLabel && statusLabel.label;
    }

    // Handler for search functionality
    const handleSearch = (e) => {
        e.preventDefault();
        let params = {};
        if (name)
            params.author_name = name;
        if (email)
            params.author_email = email;
        params.author_status = status?.value;
        if (mobileNumber)
            params.author_mobile = mobileNumber;
        if (Object.keys(params)?.length > 0)
            dispatch(getAuthorListing(params));
    };

    // Handler for resetting search filters
    const handleReset = (e) => {
        e.preventDefault();
        setName("")
        setEmail("")
        setMobileNumber("")
        setStatus(null)
        dispatch(getAuthorListing())
    }
    return (
        <div className={"overview"}>
            {/* Search form */}
            <div className={"plan"}>
                <h4 className={"examfilter_heading"}>Filter Author</h4>
                <Form>
                    <div className={"examfilter"}>
                        <h4 className={"examfilter_heading"}>Search By</h4>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label> Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={"input_pd"}
                                        value={name}
                                        placeholder="Enter Name"
                                        onChange={(event) => {
                                            setName(event.target.value);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label> Email</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={"input_pd"}
                                        value={email}
                                        placeholder="Enter Email"
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label> Mobile Number</Form.Label>
                                    <Form.Control
                                        type="number"
                                        maxLength={10} // Use maxLength instead of maxlength
                                        className={"input_pd"}
                                        value={mobileNumber}
                                        placeholder="Enter Mobile Number"
                                        onChange={(event) => {
                                            setMobileNumber(event.target.value);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label> Author Status</Form.Label>
                                    <Select
                                        onChange={(obj) => setStatus(obj)}
                                        options={AUTHOR_STATUS}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        value={status}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {/* Buttons for search and reset */}
                            <div className="d-flex">
                                <Form.Group>
                                    <button
                                        className={"exam_button"}
                                        type="submit"
                                        onClick={(e) => handleSearch(e)}
                                    >
                                        Search
                                    </button>
                                </Form.Group>
                                <Form.Group>
                                    <button
                                        className={"exam_button"}
                                        type="submit"
                                        onClick={(e) => handleReset(e)}
                                    >
                                        Reset
                                    </button>
                                </Form.Group>
                            </div>
                        </Row>
                    </div>
                </Form>
            </div>

            <div className={"all_task"} style={{ marginTop: "40px" }} >
                <div className={"examfilter"}>
                    <div className={"tablestrip"}>
                        <div className={"tablestrip_left"}>
                        </div>
                        <div className={"tablestrip_right"}>
                            <ul className={"tablestrip_list"}>
                                <li className={"tablestrip_list_item"}>
                                    <Link to={"/cms/author/manage-author-profile"}>
                                        <a href="#" className={"tablestrip_list_anchor"}>
                                            Create Author Profile
                                        </a>
                                    </Link>

                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Table for displaying video data */}
                    <div className={"exam_table_box"} style={{ marginTop: "20px" }}>
                        {/* Show loading spinner if data is being fetched */}
                        {authorListingLoading && <Loading />}
                        {/* Display table if data is available */}
                        {tableData && (
                            <DataTable
                                columns={tableCustomData}
                                data={tableData}
                                customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                                progressPending={authorListingLoading}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                            />
                        )}
                    </div>
                </div>
            </div >
        </div >
    );
}

export default AuthorHome